import React, { useContext } from 'react';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';
import { LocaleContext } from '../components/LocaleContext';

export default function TabulatorMaskDialog({
  visible,
  onHide,
  title,
  fields,
  checkedMap,
  onToggleField,
  onSelectAll,
  onDeselectAll,
  onSave,
  selectAllLabel,
  deselectAllLabel,
  saveLabel,
  getFieldLabel,
  inputIdPrefix = 'tab-mask',
  dialogWidth = '70vw',
}) {
  const { t } = useContext(LocaleContext);
  const resolvedTitle = title ?? t('Common.SetMask');
  const resolvedSelectAll = selectAllLabel ?? t('Common.SelectAll');
  const resolvedDeselectAll = deselectAllLabel ?? t('Common.DeselectAll');
  const resolvedSave = saveLabel ?? t('Common.Save');

  return (
    <Dialog header={resolvedTitle} visible={visible} style={{ width: dialogWidth }} onHide={onHide}>
      <div className="flex flex-col gap-2">
        <div className="flex flex-wrap gap-2 m-1">
          <button type="button" onClick={onSelectAll} className="px-3 py-1.5 text-sm bg-zinc-200 text-zinc-900 rounded-md hover:bg-zinc-300">
            {resolvedSelectAll}
          </button>
          <button type="button" onClick={onDeselectAll} className="px-3 py-1.5 text-sm bg-zinc-200 text-zinc-900 rounded-md hover:bg-zinc-300">
            {resolvedDeselectAll}
          </button>
        </div>
        {fields.map((field) => (
          <div key={field} className="flex flex-row border border-black rounded-md p-2 m-1">
            <Checkbox
              inputId={`${inputIdPrefix}-${field}`}
              onChange={(e) => onToggleField(field, e.checked)}
              checked={checkedMap?.[field] !== false}
            />
            <label htmlFor={`${inputIdPrefix}-${field}`} className="ml-2 cursor-pointer">
              {getFieldLabel(field)}
            </label>
          </div>
        ))}
        <button
          type="button"
          onClick={onSave}
          className="m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600"
        >
          {resolvedSave}
        </button>
      </div>
    </Dialog>
  );
}
